import { useQuery } from '@tanstack/react-query'
import { getInquiryCoordinations } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useInquiryCoordinations(inquiryId: number) {
  return useQuery({
    queryKey: queryKeys.inquiry.coordinations(inquiryId),
    queryFn: async () => {
      return getInquiryCoordinations(inquiryId)
    },
    enabled: inquiryId > 0,
  })
}
